import { Feed } from 'semantic-ui-react';

export default Feed;
